import { Icon, Label } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import {
  PiArrowClockwise,
  PiBarcode,
  PiGlobeHemisphereWest,
  PiGlobeSimpleX,
  PiQuestionMark,
  PiWarning,
  PiX,
  PiXCircle,
} from 'react-icons/pi';
import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';
import { ILabeledStatusParams, ILabeledStatusProps } from './LabeledStatus';

const labeledStatusParams: ILabeledStatusParams<DELIVERY_STATUS>[] = [
  {
    status: DELIVERY_STATUS.unknown,
    color: 'gray',
    icon: <PiQuestionMark />,
  },
  {
    status: DELIVERY_STATUS.notSend,
    color: 'black',
    icon: <PiGlobeSimpleX />,
  },
  {
    status: DELIVERY_STATUS.waiting,
    color: 'blue',
    icon: <Icon.AnimatedHourglass />,
  },
  {
    status: DELIVERY_STATUS.inProgress,
    color: 'blue',
    icon: <PiArrowClockwise />,
  },
  {
    status: DELIVERY_STATUS.published,
    color: 'green',
    icon: <PiXCircle />,
  },
  {
    status: DELIVERY_STATUS.error,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.canceled,
    color: 'gray',
    icon: <PiXCircle />,
  },
  {
    status: DELIVERY_STATUS.waitingForACKFile,
    color: 'blue',
    icon: <Icon.AnimatedHourglass />,
  },
  {
    status: DELIVERY_STATUS.inProgressProcessingACKFile,
    color: 'blue',
    icon: <Icon.AnimatedHourglass />,
  },
  {
    status: DELIVERY_STATUS.errorProcessingACKFile,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.ACKFileError,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.withdrawWaiting,
    color: 'blue',
    icon: <Icon.AnimatedHourglass />,
  },
  {
    status: DELIVERY_STATUS.publishWaiting,
    color: 'blue',
    icon: <Icon.AnimatedHourglass />,
  },
  {
    status: DELIVERY_STATUS.published,
    color: 'green',
    icon: <PiGlobeHemisphereWest />,
  },
  {
    status: DELIVERY_STATUS.waitingForAssetIds,
    color: 'blue',
    icon: <PiBarcode />,
  },
  {
    status: DELIVERY_STATUS.inProgressAssigningAssetIds,
    color: 'blue',
    icon: <PiBarcode />,
  },
  {
    status: DELIVERY_STATUS.errorAssigningAssetIds,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.withdrawInProgress,
    color: 'orange',
    icon: <Icon.AnimatedHourglass />,
  },
  {
    status: DELIVERY_STATUS.withdrawn,
    color: 'gray',
    icon: <PiXCircle />,
  },
  {
    status: DELIVERY_STATUS.withdrawError,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.unavailable,
    color: 'gray',
    icon: <PiX />,
  },
  {
    status: DELIVERY_STATUS.waitingForAccept,
    color: 'blue',
    icon: <Icon.AnimatedHourglass />,
  },
];

const LabeledDeliveryStatus = ({
  status,
  noname,
}: ILabeledStatusProps<DELIVERY_STATUS>) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      withText={!noname}
      // isClear
      title={t(
        `enum.DELIVERY_STATUS.${DELIVERY_STATUS[labeledParams.status]}`
      )}>
      {labeledParams.icon}{' '}
      {!noname &&
        t(`enum.DELIVERY_STATUS.${DELIVERY_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledDeliveryStatus;
